import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Routes } from '@/routes/routes';
import { DomainCard } from './components/DomainCard';

export default function ConnectraDashboard() {
	const navigate = useNavigate();

	return (
		<div className="space-y-6 p-6">
			<div className="flex items-center justify-between">
				<h1 className="text-2xl font-semibold">Connectra</h1>
				<Button onClick={() => navigate(Routes.CONNECTRA_CLIENT)}>
					Config
				</Button>
			</div>

			<p className="text-sm text-muted-foreground">
				Unified control plane for third-party integrations. Connect, route, and
				monitor external providers across all domains. Manage Connectra clients
				via Config.
			</p>

			<div className="grid grid-cols-2 gap-4">
				<DomainCard
					icon={
						<svg
							width="28"
							height="28"
							viewBox="0 0 24 25"
							fill="none"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
							aria-label="Communications"
							role="img"
						>
							<rect x="2" y="5" width="20" height="15" rx="2" />
							<path d="M2 8h20" />
							<path d="M8 12v5" />
							<path d="M5 12v2" />
							<path d="M11 12v3" />
							<path d="M14 12v4" />
							<path d="M17 12v2" />
						</svg>
					}
					title="Communications"
					description="Manage Email, Push, and SMS connections. Configure routing and monitor delivery analytics across all channels."
					available
					connectionCount={8}
					onClick={() => navigate(Routes.CONNECTRA_COMMUNICATIONS)}
				/>
				<DomainCard
					icon={
						<svg
							width="28"
							height="28"
							viewBox="0 0 24 25"
							fill="none"
							stroke="currentColor"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
							aria-label="Payments"
							role="img"
						>
							<rect x="2" y="5" width="20" height="15" rx="2" />
							<path d="M2 8h20" />
							<circle cx="8" cy="13" r="3" />
							<path d="M14 13h4" />
							<path d="M14 16h3" />
						</svg>
					}
					title="Payments"
					description="Connect payment gateway providers and manage transaction routing. Coming soon."
					available={false}
				/>
			</div>
		</div>
	);
}
